<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" transform="rotate(-180 20 20)" fill="#E8E8E8"/>
    <rect x="22.8203" y="29" width="12.9805" height="1.29805" transform="rotate(-135 22.8203 29)" fill="black"/>
    <rect x="13.6416" y="19.8223" width="12.9805" height="1.29805" transform="rotate(-45 13.6416 19.8223)" fill="black"/>
  </svg>
</template>